import { useDispatch } from 'react-redux';
import type { IProcessAction } from '../../../common/interfaces/IProcessAction';
import { receiveUserActions } from '../../store/authentication/actions';
import { fetchJson } from '../../store/fetch';

export function useReloadPatientAvailableActions() {
    const dispatch = useDispatch();

    return async function reloadPatientAvailableActions() {
        const result = await fetchJson(`/api/patient/getAvailableActions`, 'GET');

        if (result.json) {
            const actions = result.json.actions as IProcessAction[];

            receiveUserActions(actions)(dispatch);
        }
    };
}
